import { ApolloError, gql, useLazyQuery } from '@apollo/client';
import { MAYA_GRAPHQL_ENDPOINT } from 'basics/constants/common.constants';
import { CountryDataType } from 'basics/types/countryData.types';
import { extractApolloErrorDetails } from 'services/graphql/extractApolloErrorDetails';
import Logger from 'services/logger';

const GET_COUNTRY_DATA_BY_CODES_LAZY = gql`
  query getCountryDataByCodes($filters: CountryDataFilter) {
    getCountryDataByCodes(filters: $filters) {
      code
      products
    }
  }
`;

type UseGetCountryDataByCodesLazy = () => {
  getCountryDataByCodesLazy: Function;
  loading: boolean;
  error?: ApolloError;
  data: CountryDataType[];
};

type ResultType = {
  getCountryDataByCodes: CountryDataType[];
};

const useGetCountryDataByCodesLazy: UseGetCountryDataByCodesLazy = () => {
  const [getCountryDataByCodesLazy, { data, loading, error }] = useLazyQuery<ResultType>(GET_COUNTRY_DATA_BY_CODES_LAZY, {
    fetchPolicy: 'cache-and-network',
    context: { clientName: MAYA_GRAPHQL_ENDPOINT },
  });

  if (error) {
    const customContext = extractApolloErrorDetails(error);
    Logger.logError({
      error,
      customContext,
      transactionName: 'getCountryDataByCodesLazy.ts - useGetCountryDataByCodesLazy',
    });
  }

  return {
    getCountryDataByCodesLazy,
    data: data?.getCountryDataByCodes || [],
    loading,
    error,
  };
};
export default useGetCountryDataByCodesLazy;
